import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-refresh-dialog',
    standalone: true,
    template: `
        <div class="refresh-dialog-backdrop">
            <div class="refresh-dialog">
                <div class="refresh-dialog-header">{{ title }}</div>
                <div class="refresh-dialog-body">
                    <p>{{ message }}</p>
                </div>
                <div class="refresh-dialog-footer">
                    <button type="button" class="btn btn-primary" (click)="onRefresh()">Refresh</button>
                </div>
            </div>
        </div>
    `,
    styles: [`
        :host {
            display: block;
        }
        .refresh-dialog-backdrop {
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1100;
        }
        .refresh-dialog {
            background: #fff;
            border-radius: 0.375rem;
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
            width: 100%;
            max-width: 28rem;
        }
        .refresh-dialog-header {
            padding: 0.75rem 1rem;
            font-weight: 600;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
        .refresh-dialog-body {
            padding: 1rem;
        }
        .refresh-dialog-body p {
            margin: 0;
        }
        .refresh-dialog-footer {
            padding: 0.75rem 1rem;
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: flex-end;
        }
    `]
})
export class RefreshAppDialogComponent {
    title = 'Session Expired';
    message = '';

    @Output() refresh = new EventEmitter<void>();

    onRefresh(): void {
        this.refresh.emit();
    }
}
